// src/components/EntrepreneursFilterBar.js
//
// Barra de filtros da vitrine de empreendedores (Fase D.4).
// Suporta multi-seleção de categorias, filtro de localização (estado/cidade)
// e flag "somente destaques".
import React from 'react';

const CATEGORY_LABELS = {
  moradia: 'Moradia',
  alimentacao: 'Alimentação',
  trocas: 'Trocas',
  transporte: 'Transporte',
  documentacao: 'Documentação',
  emprego: 'Emprego',
  comunicacao: 'Comunicação',
  treinamento: 'Treinamento',
  saude: 'Saúde',
  outros: 'Outros',
};

const BRAZILIAN_STATES = [
  'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO',
  'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
  'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO',
];

const EntrepreneursFilterBar = ({
  selectedCategories,
  onToggleCategory,
  selectedState,
  onStateChange,
  cityFilter,
  onCityChange,
  showHighlightsOnly,
  onToggleHighlights,
  onClear,
}) => {
  const safeSelected = Array.isArray(selectedCategories) ? selectedCategories : [];
  const hasFilters =
    safeSelected.length > 0 ||
    selectedState ||
    cityFilter ||
    showHighlightsOnly;

  return (
    <div className="bg-white rounded-2xl p-4 mb-5 border border-gray-200">
      <div className="flex flex-wrap items-end gap-3">
        <label className="flex flex-col text-sm text-gray-700">
          Estado
          <select
            value={selectedState}
            onChange={(e) => onStateChange(e.target.value)}
            className="border border-gray-300 rounded-lg px-2 py-1 mt-1 min-w-[120px]"
          >
            <option value="">Todos</option>
            {BRAZILIAN_STATES.map((uf) => (
              <option key={uf} value={uf}>{uf}</option>
            ))}
          </select>
        </label>
        <label className="flex flex-col text-sm text-gray-700">
          Cidade
          <input
            type="text"
            value={cityFilter}
            onChange={(e) => onCityChange(e.target.value)}
            placeholder="Filtrar por cidade"
            className="border border-gray-300 rounded-lg px-2 py-1 mt-1 min-w-[160px]"
          />
        </label>
        <label className="flex items-center text-sm text-gray-700 mt-5 gap-2">
          <input
            type="checkbox"
            checked={showHighlightsOnly}
            onChange={(e) => onToggleHighlights(e.target.checked)}
          />
          Somente destaques
        </label>
        {hasFilters && (
          <button
            type="button"
            onClick={onClear}
            className="mt-5 text-sm text-pink-600 hover:underline"
          >
            Limpar filtros
          </button>
        )}
      </div>
      <div className="mt-3">
        <p className="text-sm font-semibold text-gray-700 mb-2">Categorias</p>
        <div className="flex flex-wrap gap-2">
          {Object.entries(CATEGORY_LABELS).map(([key, label]) => {
            const selected = safeSelected.includes(key);
            return (
              <button
                key={key}
                type="button"
                onClick={() => onToggleCategory(key)}
                className={`text-sm px-3 py-1 rounded-full border transition-colors ${
                  selected
                    ? 'bg-purple-refugia text-white border-purple-refugia'
                    : 'bg-white text-gray-700 border-gray-300 hover:border-purple-refugia'
                }`}
              >
                {label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EntrepreneursFilterBar;
